import Contact from "../../../../src/components/contact.js";
import * as React from 'react';
export default {
  Contact,
  React
};